<template>
  <ui-component-modal
    :modalTitle="$t('Components.Notes.ModalCreateNote.Modal_Title')"
    :isSaving="isSaving"
    :onClickCancel="onClickCancel"
    :onClickSave="createNote"
    :showModal="showModal"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :savingSuccessMessage="
      $t('Components.Notes.ModalCreateNote.Modal_MessageSuccess')
    "
    :savingErrorMessage="
      $t('Components.Notes.ModalCreateNote.Modal_MessageError')
    "
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :buttonLabelConfirm="
      $t('Components.Notes.ModalCreateNote.Modal_ButtonSave')
    "
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <ui-base-input-field
        class="mb-6"
        :label="$t('Components.Notes.ModalEditNote.Modal_Subtitle')"
        type="text"
        v-model="newNote.Subject"
        :placeholder="
          $t('Components.Notes.ModalEditNote.Modal_PlaceholderSubject')
        "
        :required="true"
        :error="subjectError"
        @input="$v.newNote.Subject.$touch()"
        @blur="$v.newNote.Subject.$touch()"
      />
      <textarea
        rows="5"
        type="text"
        ref="body"
        :placeholder="
          $t('Components.Notes.ModalCreateNote.Modal_PlaceholderText')
        "
        v-model="newNote.Body"
        class="textarea has-margin-bottom"
        @keyup.ctrl.enter="createNote"
      ></textarea>

      <div v-if="locationSettings.AllowPublicNotes && showNoteVisibility">
        <div class="tabs is-toggle">
          <ul>
            <li :class="{
                'is-active': newNote.Visibility === 'Internal',
              }">
              <a @click="newNote.Visibility = 'Internal'">
                <span>{{
                  $t('Components.Notes.ModalCreateNote.Label_Private')
                }}</span>
              </a>
            </li>
            <li :class="{
                'is-active': newNote.Visibility === 'Public',
              }">
              <a @click="newNote.Visibility = 'Public'">
                <span>{{
                  $t('Components.Notes.ModalCreateNote.Label_Public')
                }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState } from 'vuex'
import noteProvider from '@/providers/note'
import { required } from 'vuelidate/lib/validators'
// const touchMap = new WeakMap()

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    onClickCancel: {
      type: Function,
      required: true,
    },

    itemId: {
      default: 0,
      type: Number,
    },

    typeId: {
      default: 'None',
      type: String,
    },

    linkItemId: {
      default: 0,
      type: Number,
    },

    linkTypeId: {
      default: 'None',
      type: String,
    },

    viewType: {
      default: 'normal',
      type: String,
    },

    showNoteVisibility: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isSavingError: false,
      isSavingSuccess: false,
      isSaving: false,
      locationId: Number(this.$route.params.locationId),
      newNote: this.setNewNote(),
    }
  },

  created() {
    this.newNote = this.setNewNote()
  },

  mounted() { },

  computed: {
    ...mapState('locationStore', ['locationState']),

    locationSettings() {
      let settings = null

      if (this.locationState) {
        settings = this.locationState.Settings
      }

      return settings
    },

    subjectError() {
      const errors = []
      if (!this.$v.newNote.Subject.$dirty) return errors
      if (!this.$v.newNote.Subject.required) {
        errors.push(
          this.$t('Form.InputErrors.RequiredField', {
            fieldLabel: this.$t(
              'Components.Notes.ModalEditNote.Modal_Subtitle'
            ),
          })
        )
      }
      return errors
    },
  },

  /**
   * Form validation rules
   */
  validations() {
    return {
      newNote: {
        Subject: {
          required,
        },
      },
    }
  },

  methods: {
    createNote() {
      let self = this
      if (!this.isSaving) {
        this.isSaving = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          // 'ERROR'
          this.isSaving = false
        } else {
          // do your submit logic here
          // 'PENDING'
          noteProvider.methods
            .createNote(self.newNote)
            .then((response) => {
              if (response.status === 201) {
                self.$emit('noteCreated', response.data)

                self.newNote = self.setNewNote()

                // Show toast notification?

                self.onClickCancel()
              }
            })
            .catch((error) => {
              self.isSavingError = true
            })
            .finally(() => {
              self.isSaving = false
            })
        }
      }
    },

    setNewNote() {
      return {
        Body: '',
        DeliveryAt: 0,
        DoBefore: 0,
        Id: 0,
        IsToDo: false,
        ItemId: this.itemId,
        LinkItemId: this.linkItemId,
        LinkTypeId: this.linkTypeId,
        AccountIds: [],
        Subject: '',
        TypeId: this.typeId,
        WorkEnvironment: 'Manage',
        EnvironmentId: this.locationId,
        Visibility: 'Internal',
      }
    },
  },
}
</script>
